import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { PQRNumeroDiasLetivosDto } from '../../dtos/pqr-numero-dias-letivos.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'

interface ListPQRNumerosDiasLetivos {
  _embedded: {
    'pqr-numero-dias-letivos': PQRNumeroDiasLetivosDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRNumeroDiasLetivosService {
  private apiUrl = `${environment.apiUrl}/pqr-numero-dias-letivos`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRNumeroDiasLetivos(): Observable<PQRNumeroDiasLetivosDto[]> {
    return this.caqRequestService
      .get<ListPQRNumerosDiasLetivos>(this.apiUrl)
      .pipe(map((response) => response._embedded['pqr-numero-dias-letivos']));
  }

  salveListaDePQRNumeroDiasLetivos(requisicao: PQRNumeroDiasLetivosDto){
    return firstValueFrom(this.caqRequestService
      .put<PQRNumeroDiasLetivosDto>(`${this.apiUrl}/${requisicao.codPqrNumeroDiasLetivos}`, requisicao)
      .pipe(map((response) => response)));
  }
}
